import {
    SHOW_RIGHT_POPUP_PROPS,
    HIDE_RIGHT_POPUP_BOX
} from "./actionConstants";

export const showRightPopUpeBox = (payload) => ({
    type: SHOW_RIGHT_POPUP_PROPS,
    payload
});

export const hideRightPopUpBox = () => ({
    type: HIDE_RIGHT_POPUP_BOX
});